export enum SidenavType {
  POLIZZE = 'polizze',
  VERTRAG = 'vertrag',
  POSITION = 'position',
  PERSON = 'person',
  VERBUND = 'verbund',
  FAHRZEUG = 'fahrzeug',
  VERTRETER = 'vertreter',
  SCHADEN = 'schaden',
  HAUSHALT = 'haushalt',
  GEBAEUDE = 'gebaeude',
  HOTLINE = 'hotline',
  BETREUER = 'betreuer',
  VSB = 'vsb',
  ASSISTANCE = 'assistance',
  ASSISTANCEPOLIZZE = 'assistancePolizze',
  BETREUERKNOTEN = 'betreuerknoten',
  TEXTE = 'texte',
  ZAHLUNG = 'zahlung',
  FAMILIENPASS = 'familienpass',
  MAKLERFAMILIENPASS = 'maklerfamilienpass',
  PARTNER = 'partner',
  SCHADENZAHLUNGEMPF = 'schadenzahlungempf',
  SCHADENBETEILIGTER = 'schadenbeteiligter',
  ZULASSUNG = 'zulassung',
  ZULASSUNG_KENNZEICHEN = 'zulassung_kennzeichen',
  BEZUGSBERECHTIGTER = 'bezugsberechtigter',
  BENUTZER = 'benutzer',
  MAKLERPERSON = 'maklerperson',
  MAKLERPOLIZZE = 'maklerpolizze',
  MAKLERSCHADEN = 'maklerschaden',
  BEITRAGSZAHLER = 'beitragszahler',
  VERSPERSON = 'versperson',
  POLIZZEBUCHUNG = 'polizzebuchung',
  MAKLERBETREUER = 'maklerbetreuer',
  MAKLERVERTRETER = 'maklervertreter',
  MAKLERDOWNLOAD = 'maklerdownload',
  RKW = 'rkw',
  CMS = 'cms',
  DATENSCHUTZ = 'datenschutz',
  KUNDENDATENADMIN = 'kundendatenadmin',
  UNGEKLAERTEZAHLUNGEN_ARCHIV = 'ungeklaertezahlungen_archiv',
  BETREUERDATENARCHIVADMIN = 'betreuerdatenarchivadmin',
  REFERATADMIN = 'referatadmin',
}
